import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import VueAwesomeSwiper from 'vue-awesome-swiper';
// import 'swiper/css/swiper.css';  // 引入核心样式

// Vue.use(VueAwesomeSwiper);
function updateCSSVariables() {
  const width = document.documentElement.clientWidth
  const scale = width / 1920 // 1920是设计稿宽度
  document.documentElement.style.setProperty('--scale', scale)
}
 
updateCSSVariables()
window.addEventListener('resize', updateCSSVariables)

Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
